<template>
  <div class="banner-pan banner-pan-pc posRe">
    <div class="container-banner posRe">
      <div class="logo" v-if="panLogo">
        <img class="animated bounceIn" :src="panLogo"/>
      </div>
      <a v-if="seePanUrl" :href="seePanUrl" class="icon-img icon-see-pan" target="_pan"></a>
      <div class="iframe iframe-pan" :class="[panUrl||panLogo?'':'no-iframe-pan']" id="iframe-pan">
        <iframe id="frameA" ref="iframeA" class="" :src="panUrl" name="frameA"></iframe>
        <!--<iframe id="frameA" ref="iframeA" class="" src="http://pano.szscmap.com/city/sichuan/" name="frameA"></iframe>-->
      </div>
    </div>
    <div class="swiper-container container-pan-city">
      <div class="swiper-wrapper">
        <template v-if="paoThumbData&&paoThumbData.length">
          <template v-for="(list,index) in paoThumbData">
            <div class="swiper-slide" :class="[(paoThumbIndex==index?'active':'')]" :key="'pan'+index">
              <div class="pan-name" :class="[list.pano_id?'':'no-list-data']" @click="panClick(index,list.pano_id)">
                <div class="pan-text"><span>{{list.title||'重点推荐'}}</span></div>
                <div class="pan-icon"></div>
              </div>
            </div>
          </template>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
//  import Bus from '@/common/bus.js'
export default {
  name: 'panCity',
  props: ['state'],
  data () {
    return {
      params: {
        cityId: 0,
        typeId: 0,
        keyWords: ''
      },
      panLogo: '',
      panUrl: '',
      seePanUrl: '',
      paoThumbData: [],
      paoThumbIndex: 0,
      iframeWin: {},
      swiperPanObj: '',
      panActiveIndex:0,
      timer:null,
    }
  },
  created () {
    let that = this;
    let c = JSON.parse(that.publicJs.decode(that.$route.query)) || {};
    that.params.cityId = c.cityId;
    that.params.typeId = c.typeId;
    that.httpData()
  },
  mounted () {
    let that = this;
    let i=that.$root.cityPanIndex;
    that.panActiveIndex=i;
    window.addEventListener('message', function (event) {
      let data = JSON.parse(JSON.stringify(event.data));
      if (data.msg === 'success') {
        if(data.isList){
          let len=data.data && data.data.length?data.data.length:0;
          if(len){
            that.paoThumbData = data.data;
            that.swiperPan(i);
          }
        }
        if (data.activeIndex >= 0) {
          that.paoThumbIndex = data.activeIndex;
          that.seePanUrl = that.paoThumbData[data.activeIndex].url
        }
      }
    })
    that.iframeWin = that.$refs.iframeA.contentWindow
  },
  methods: {
    httpData: function () {
      let that = this;
      that.httpAjax.getAjax('CityWebService.asmX/GetSiteInfoByCity', {cityId: that.params.cityId}).then(function (res) {
        if (res.code === 1) {
          let data = res.data && res.data.length ? JSON.parse(JSON.stringify(res.data[0])) : {};
         /* let cityCard={};
          if(data&&JSON.stringify(data)!='{}'){
            cityCard.name=data.charmPanoUrl?data.charmName:'';
            cityCard.imgSrc=data.charmPanoImg;
            cityCard.panoUrl=data.charmPanoUrl;
            cityCard.cityBool=true;
            cityCard.defaultBool=data.charmPanoUrl?false:true;
          }

          Bus.$emit('GetSiteInfoByCityData',cityCard)*/
//          that.$emit('GetSiteInfoByCityData',data);
          that.panLogo = data.logo || '';
          that.panUrl = data.panoUrl || '';
          that.publicJs.panMousewheel(function (val) {
            if(val){
              clearInterval(that.timer);
            }else {
              that.timeSwiper(that.panActiveIndex)
            }
          });
        }
      }, function (err) {
        console.log(err)
      })
    },
    panClick: function (index,pano_id) {
      let that=this;
      if(pano_id){
        clearInterval(that.timer);
        that.swiperPanObj.slideTo(index);
        that.iframeWin.postMessage({
          cmd: 'activeIndex',
          activeIndex: index
        }, '*');
        that.panActiveIndex=index;
      }
    },
    swiperPan: function (n) {
      let _that = this;
      // eslint-disable-next-line
      _that.swiperPanObj = new Swiper('.container-pan-city', {
        direction: 'vertical',
        slidesPerView: 5,
        spaceBetween: 10,
        watchOverflow: true,
        on:{
          init:function(){
            if(n>0){
              _that.iframeWin.postMessage({
                cmd: 'activeIndex',
                activeIndex: n
              }, '*');
              _that.timeSwiper(n);
            }else {
              _that.timeSwiper(this.activeIndex)
            }
          },
          slideChangeTransitionStart:function(){
            console.log('slideChangeTransitionStart')
          },
        }
      })
      /*
      setTimeout(function () {
      }, 50)
      */
    },
    timeSwiper:function (n) {
      let _that=this,
        list=_that.paoThumbData,
        len=list&&list.length?list.length:0;

      if(len<=1){
        return false;
      }

      _that.timer=setInterval(function () {
        let i=((n==(len-1))?0:n+1);
        if(list[i].pano_id){
          _that.swiperPanObj.slideTo(i);
          _that.iframeWin.postMessage({
            cmd: 'activeIndex',
            activeIndex: i
          }, '*');
        }
        _that.panActiveIndex=i;
        clearInterval(_that.timer);

      },15000)
    },
  },
  beforeDestroy(){
    this.$root.cityPanIndex=this.panActiveIndex;
    if(this.timer){
      clearInterval(this.timer)
    }
  },
  watch: {
    panActiveIndex:function (newVal,b) {
      if(newVal!=b){
        this.timeSwiper(newVal)
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .container-banner{
    height: 700px;
    background-color:#e7f6ff;
  }
  .logo{
    position: absolute;
    width: 700px;
    height: 280px;
    left: 50%;
    margin-left: -350px;
    z-index: 2;
    top:184px;
  }
  .logo img{
    height: 100%;
    object-fit: scale-down;
  }
</style>



// WEBPACK FOOTER //
// src/components/panCity.vue